import React from "react";
import { Link } from "react-router-dom";
import { Youtube, Facebook, Instagram, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#112C54] text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_examen-prep-mx/artifacts/0mkzmukl_Logo%20Mi%20Prepa%20en%20Shorts.jpeg"
                alt="Mi Prepa en Shorts"
                className="h-12 w-12 rounded-full object-cover"
              />
              <span className="font-bold text-xl" style={{ fontFamily: 'Outfit' }}>
                Mi Prepa en Shorts
              </span>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed">
              Tu plataforma para acreditar el bachillerato mexicano con programas de preparacion para Exacer-COLBACH y Acredita-Bach.
            </p>
          </div>

          {/* Programs */}
          <div>
            <h4 className="font-semibold text-lg mb-4" style={{ fontFamily: 'Outfit' }}>Programas</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/free" className="text-slate-300 hover:text-[#20D3C0] transition-colors text-sm">
                  Contenido Gratuito
                </Link>
              </li>
              <li>
                <span className="text-slate-300 text-sm">
                  Exacer-COLBACH
                </span>
              </li>
              <li>
                <span className="text-slate-300 text-sm">
                  Acredita-Bach
                </span>
              </li>
            </ul>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4" style={{ fontFamily: 'Outfit' }}>Enlaces</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/auth" className="text-slate-300 hover:text-[#20D3C0] transition-colors text-sm">
                  Iniciar Sesion
                </Link>
              </li>
              <li>
                <Link to="/events" className="text-slate-300 hover:text-[#20D3C0] transition-colors text-sm">
                  Clases en Vivo
                </Link>
              </li>
              <li>
                <a href="https://wa.me/529981851150" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-[#20D3C0] transition-colors text-sm">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-semibold text-lg mb-4" style={{ fontFamily: 'Outfit' }}>Siguenos</h4>
            <div className="flex gap-4">
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"
                className="bg-white/10 hover:bg-[#20D3C0] p-3 rounded-full transition-all hover:-translate-y-1"
                data-testid="social-youtube">
                <Youtube className="w-5 h-5" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"
                className="bg-white/10 hover:bg-[#20D3C0] p-3 rounded-full transition-all hover:-translate-y-1"
                data-testid="social-facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"
                className="bg-white/10 hover:bg-[#20D3C0] p-3 rounded-full transition-all hover:-translate-y-1"
                data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://wa.me/529981851150" target="_blank" rel="noopener noreferrer"
                className="bg-white/10 hover:bg-[#20D3C0] p-3 rounded-full transition-all hover:-translate-y-1"
                data-testid="social-whatsapp">
                <Phone className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center text-slate-400 text-sm space-y-4">
          <p>&copy; {new Date().getFullYear()} Mi Prepa en Shorts. Todos los derechos reservados.</p>
          <p className="text-xs text-slate-500 max-w-3xl mx-auto leading-relaxed" data-testid="footer-disclaimer">
            Los contenidos, clases y todos los materiales didacticos, han sido desarrollados a partir de guias, los materiales y documentos publicos de las instituciones evaluadoras COLBACH o CENEVAL. Mi Prepa en Shorts no tiene ninguna relacion con estas instituciones ni directa ni indirectamente.
          </p>
        </div>
      </div>
    </footer>
  );
}
